<template>
  <v-dialog
    v-model="dialog"
    max-width="700"
    persistent
    :fullscreen="$vuetify.breakpoint.mobile"
  >
    <client-form
      @cancel="handleClickCancel()"
      @submitted="handleSubmitForm()"
      :visible="dialog"
    ></client-form>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
import ClientForm from "../forms/ClientForm.vue";

export default {
  components: { ClientForm },
  data() {
    return {
      dialog: false
    };
  },

  methods: {
    init(initialClient = null) {
      this.dialog = true;
      this.showClient(initialClient.id);
    },
    handleClickCancel() {
      this.dialog = false;
      this.$emit("cancel");
    },
    handleSubmitForm() {
      this.dialog = false;
      this.$emit("submited");
    },
    ...mapActions("clients", ["showClient"])
  }
};
</script>
